// extracted by mini-css-extract-plugin
export default {"year-options":"style_year-options__hvOZA","task-preference":"style_task-preference__6QyLX","no-margin-top":"style_no-margin-top__jlEnQ","nowrap":"style_nowrap__OJ0KB"};